<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>Change color</h1>
        <v-row>
          <v-col class="d-flex justify-center">
            <v-color-picker v-model="color" mode="hexa" canvas-height="300"></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn :loading="isLoading" @click="sendColor" color="info" block>ส่ง</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <h1>MQTT</h1>
        <mqtt></mqtt>
      </v-col>
    </v-row>

    <!-- Login dialog -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card :loading="login.loading">
        <v-card-title class="headline text-center">Please login.</v-card-title>
        <v-card-text>
          <p>login and try again.</p>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field label="LoRa-CAT username*" v-model="login.username" required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Password*" type="password" v-model="login.password" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="getToken">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import mqtt from "@/components/MQTT.vue";
const GET_TOKEN = "https://loraiot.cattelecom.com/portal/iotapi/auth/token";
const SEND_DOWNLINK =
  "https://loraiot.cattelecom.com/portal/iotapi/core/devices/70B3D5499458E656/downlinkMessages";

export default {
  name: "Home",
  components: {
    mqtt
  },
  data() {
    return {
      color: "",
      dialog: false,
      isLoading: false,
      login: {
        username: "",
        password: "",
        loading: false
      }
    };
  },
  computed: {
    getColor() {
      const len = this.color.length;
      const colorHex = this.color.slice(1, len - 2);
      return colorHex;
    }
  },
  methods: {
    async sendColor() {
      this.isLoading = true;
      const KEY = `Bearer ${localStorage.getItem("token")}`;
      const data = {
        payloadHex: this.getColor,
        targetPorts: "2"
      };
      try {
        await axios.post(SEND_DOWNLINK, data, {
          headers: { Authorization: KEY }
        });
      } catch (error) {
        console.error(error.message);
        this.dialog = true; // open login
      }
      this.isLoading = false;
    },
    async getToken() {
      this.login.loading = true;
      const data = {
        username: this.login.username,
        password: this.login.password
      };
      try {
        const res = await axios.post(GET_TOKEN, data);
        const token = res.data.access_token;
        localStorage.setItem("token", token);
        this.dialog = false;
        this.login.loading = false;
        this.login.password = "";
      } catch (error) {
        this.login.loading = false;
        console.error(error.message);
      }
    },
    toHex() {
      const hexColor = this.getColor;
      let hex = "";
      for (let ch of hexColor) {
        hex += ch.toString(16);
      }
    }
  }
};
</script>
